import { Typography } from '@breetometer/components';
import { CopyIcon, FullStopIcon } from 'BreetAssets';
import {
	copyToClipboard,
	isConversions,
	isEdits,
	isWithdrawals,
	type ITransactionHistory,
	type TransactionHistoryType,
} from 'BreetHelpers';

import { currencyDisplayNames, type ITableColumnDestination } from '../../WalletTransactions.helpers';

const TableColumnDestination = ({ row }: ITableColumnDestination) => {
	const renderDestinationContent = (transaction: ITransactionHistory<TransactionHistoryType>) => {
		if (isWithdrawals(transaction)) {
			const { meta } = transaction.doc;
			if (meta.type === 'nuban' || meta.type === 'ghs_bank') {
				return (
					<>
						<div className='copy-container flex-row-center'>
							<Typography className='no-margin copy-container'>{meta.accountNumber}</Typography>
							&nbsp;
							<CopyIcon
								focusable
								variant='negative'
								className='cursor_pointer svg-dark'
								onClick={copyToClipboard(meta.accountNumber, 'Bank Account Number copied successfully')}
							/>
						</div>
						<Typography
							as='span'
							className='color-primary-50'
						>
							{meta.bankName}
							&nbsp;&nbsp;
							<FullStopIcon />
							&nbsp;&nbsp;
							{meta.accountName}
						</Typography>
					</>
				);
			}

			return <Typography className='color-primary-50'>Crypto Withdrawal</Typography>;
		}
		if (isEdits(transaction)) {
			const currencyName = currencyDisplayNames[transaction.currency.toUpperCase()] ?? '...';
			return <Typography className='color-primary-50'>{`${currencyName} Wallet`}</Typography>;
		}
		if (isConversions(transaction)) {
			const currencyKey = transaction.doc.to?.toUpperCase() ?? '';
			const currencyName = currencyDisplayNames[currencyKey] ?? '...';
			return <Typography className='color-primary-50'>{`${currencyName} Wallet`}</Typography>;
		}
		return null;
	};

	return <div className='transaction-payout-cell'>{renderDestinationContent(row)}</div>;
};

export default TableColumnDestination;
